import {
  collection,
  getDocs,
  doc,
  getDoc,
  type CollectionReference,
  type DocumentData,
} from 'firebase/firestore';
import firestore, { currentUser } from './firestore';
import { readQuerySnapshot } from './firestoreData';

const getCollection = async <T>(
  collectionRef: CollectionReference<DocumentData>,
): Promise<T[]> => {
  const resp = await getDocs(collectionRef);
  return readQuerySnapshot<T>(resp);
};

const acceptedUsersCollection = (id: string) =>
  collection(firestore, `users/${id}/acceptedUsers`);

const findAppUserId = async (appId: string): Promise<User> => {
  const authUser = currentUser();
  if (!authUser?.uid) {
    throw new Error('A signed-in Firebase user is required');
  }

  const acceptedUsers = await getCollection<AcceptedUser>(
    acceptedUsersCollection(authUser.uid),
  );
  const primaryUser: User = {
    id: authUser.uid,
    label: authUser.email ?? authUser.uid,
  };

  const users = [
    primaryUser,
    ...acceptedUsers.map((user) => ({ id: user.id, label: user.email })),
  ];

  for (const user of users) {
    try {
      const docRef = doc(firestore, `users/${user.id}/applications/${appId}`);
      // eslint-disable-next-line no-await-in-loop -- early return on first match
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) return user;
    } catch (err) {
      // will throw an error if user doesn't have access
      console.error(err);
    }
  }

  return primaryUser;
};

interface User {
  id: string;
  label: string;
}

interface AcceptedUser {
  email: string;
  id: string;
}

export default findAppUserId;
